<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      :uploadField="false"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="users"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.partner_id`]="{ item }">
              {{ showPartnerName(item) }}
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item.active) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createUser"
        @update="updateUser"
        :user="user"
        :edit="editMode"
        :partners="partners"
        :roles="roles"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="user"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/user/form.vue";
import searchBar from "@/components/searchBar.vue";
import { userHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";
export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      user: {},
      currentItem: {},
      showDialog: false,
      users: [],
      partners: [],
      roles: [],
      search: "",
      headers: userHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Users" }]);
    this.initialise();
    this.getPartners();
    this.getRoles();
  },
  methods: {
    initialise() {
      this.getUsers();
    },
    async getRoles() {
      await this.$axios.get("roles").then((res) => {
        this.roles = res.data.data;
      });
    },
    async getUsers() {
      await this.$axios
        .get("users")
        .then((res) => {
          this.users = res.data.data.sort((a, b) => b.id - a.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPartners() {
      await this.$axios.get("partners").then((res) => {
        this.partners = res.data.data;
      });
    },
    async createUser(data) {
      await this.$axios
        .post("users", { user: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "User created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateUser(data) {
      await this.$axios
        .put("users/" + data.id, { user: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "User updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updateUser({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },

    edit(item) {
      this.user = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.currentItem = {};
      this.user = {};
    },
    showPartnerName(item) {
      return this.partners.find((p) => p.id === item.partner_id)?.name;
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const partnerName = this.showPartnerName(item) || "";
      const activeStatus = this.showActiveStatus(item.active);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        partnerName.toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
